import { render } from "./image-upload.vue?vue&type=template&id=5cf66d2f"
import script from "./image-upload.vue?vue&type=script&lang=ts"
export * from "./image-upload.vue?vue&type=script&lang=ts"

import "./image-upload.vue?vue&type=style&index=0&id=5cf66d2f&lang=scss"
script.render = render

export default script